import {
  SPARK_APP_STATUS_PROGRESS,
  SPARK_APP_STATUS_WAIT,
  SPARK_APP_STATUS_PAUSE,
  SPARK_APP_STATUS_INSTALL,
  SPARK_APP_STATUS_FINISH,
  SPARK_APP_STATUS_UN_DOWNLOAD,
  SPARK_APP_START_DOWNLOAD_CODE,
  SPARK_APP_PAUSE_DOWNLOAD_CODE,

  STATUS_ON_WAITING,
  STATUS_ON_DOWNLOADING,
  STATUS_ON_UN_DOWNLOAD,
  STATUS_ON_PAUSE,
  STATUS_ON_FINISH,
  STATUS_ON_INSTALL,

  SPARK_CHANNEL,

} from './constant';

let downProcess = 0;// 存储暂停的显示下载进度
function HandleSparkAppClientDownload() {
  this.gameInfo = {};
  this.getChannel = () => SPARK_CHANNEL;
  this.iosDownLoadGameInfo = {};
  /**
   * 闪现的下载状态 映射对应心悦下载状态码
   * @param status
   * @returns {*|number}
   */
  this.getStatusCode = (status) => {
    const mapping = {
      [SPARK_APP_STATUS_WAIT]: STATUS_ON_WAITING,
      [SPARK_APP_STATUS_PROGRESS]: STATUS_ON_DOWNLOADING,
      [SPARK_APP_STATUS_PAUSE]: STATUS_ON_PAUSE,
      [SPARK_APP_STATUS_FINISH]: STATUS_ON_INSTALL,
      [SPARK_APP_STATUS_INSTALL]: STATUS_ON_FINISH,
      [SPARK_APP_STATUS_UN_DOWNLOAD]: STATUS_ON_UN_DOWNLOAD,
    };
    return mapping[status] || STATUS_ON_UN_DOWNLOAD;
  };
  this.setGameInfo = (GameInfos) => {
    const {
      game_name: gameName, version,
      android_pkg_name: androidPkgName, ios_pkg_name: iosPkgName, ios_download_url: iosDownloadUrl,
      android_download_url: androidDownloadUrl, ios_url_scheme: iosUrlScheme, qq_appid: gameQQAppid,
      icon, apk_md5: md5, package_size: packageSize, game_code: gameCode, android_cdn_channels: androidCdnChannels = {},
    } = GameInfos || {};
    const params = {
      iconUrl: icon,
      url: androidDownloadUrl,
      packageName: androidPkgName,
      appName: gameName,
      versionCode: version,
      packageSize,
      // 标志位，默认自动下载安装。 bit0 是否自动安装，bit1是否强制wifi, bit2是否检查wifi，bit3是否在任务栏提示,bit4是否回调下载信息,bit5是否校验安装包签名信息,bit6是否静默下载
      // eslint-disable-next-line no-restricted-properties
      flags: Math.pow(2, 3) + Math.pow(2, 4) + Math.pow(2, 6) + Math.pow(2, 0),
      mExtData: {
        gameCode,
        apkMd5: md5,
      },
    };
    // 有特定渠道
    const specialChannel = androidCdnChannels[this.getChannel()];
    if (specialChannel && typeof specialChannel === 'object') {
      if (specialChannel.download_url) {
        params.url = specialChannel.download_url;
      }
      if (specialChannel.file_size) {
        params.packageSize = specialChannel.file_size;
      }
      if (specialChannel.md5) {
        params.mExtData.apkMd5 = specialChannel.md5;
      }
    }
    this.iosDownLoadGameInfo = {
      iosurl: iosDownloadUrl,
      iosPkgName,
      scheme: iosUrlScheme,
      gameAppId: gameQQAppid, // 用于上报染色
    };
    this.gameInfo = params;
    console.log('-----HandleSparkAppClientDownload this.gameInfo =----', this.gameInfo);
    return params;
  };
  // 审批不显示
  this.isShowDownloadComponent = () => !window.SX_WEB.tool.env.isSwitchOn;
  this.doDownloadInIOS = () => {
    console.log(
      '--------------doDownloadInIOS -this.iosDownLoadGameInfo=', this.iosDownLoadGameInfo,
      'app spark version =', this.getAppVersion(),
    );
    if (window.SX_WEB.tool.env.ios) {
      if  (this.isAppVersionBiggerThan([1, 9, 15, 150])) {
        console.warn('-----launchAppZTSDK----Appstore----------');
        //  专属拉起appstore 并且上报参数做染色 >= 1.9.15.152
        window.SX_WEB?.jsBridge.app.launchAppZTSDK({
          downloadUrl: this.iosDownLoadGameInfo.iosurl,
          scheme: this.iosDownLoadGameInfo.iosUrlScheme,
          gameAppId: this.iosDownLoadGameInfo.gameAppId,
          packageName: this.iosDownLoadGameInfo.iosPkgName,
        });
        console.warn('-----launchAppZTSDK------Appstore--------');
      } else  {
        console.warn('-----launchApp----Appstore----------');
        window.SX_WEB?.jsBridge.app.launchApp({
          downloadUrl: this.iosDownLoadGameInfo.iosurl,
          scheme: this.iosDownLoadGameInfo.iosUrlScheme,
        });
        console.warn('-----launchApp----Appstore----------');
      }
    }
  };
  /**
   *
   * @param callback
   * @param pauseImmediate  为实现一进页面获取暂停的下载进度，需要马上关闭下载
   */
  this.startDownload = (callback, pauseImmediate) => {
    console.log('--------------startDownload -this.gameInfo=', this.gameInfo);
    const that = this;
    window.SX_WEB?.jsBridge.app.downloadApk({
      actionCode: SPARK_APP_START_DOWNLOAD_CODE,
      ...this.gameInfo,
      callback: async (res) => {
        console.log('startDownload spark callback', res);
        // ############### 闪现app 进入模拟查询下载进度|重新触发app安装---》避免触发重新下载
        if (pauseImmediate === true && res.type === SPARK_APP_STATUS_PROGRESS) {
          console.log('startDownload pauseImmediate spark callback', res);

          that.stopDownloadApp();
          const { progress = 0 } = res;
          let type = SPARK_APP_STATUS_PAUSE;
          if (progress <= 1) {
            type = SPARK_APP_STATUS_UN_DOWNLOAD;
          }
          if (typeof callback === 'function') {
            const simulateInfo = that.getSimulateInfo({ ...res, type });
            callback(simulateInfo);
          }
          return;
        }
        // ###############
        if (typeof callback === 'function') {
          const simulateInfo = that.getSimulateInfo(res);
          console.log('getSimulateInfo =', simulateInfo);
          callback(simulateInfo);
        }
      },
    });
  };
  //  需要模拟下载进度 显示已下载大小
  this.getSimulateInfo = ({ type = 'progress', progress = 0 }) => {
    const packageSize = parseInt(this.gameInfo.packageSize, 10);
    if (progress > 0) {
      downProcess = progress;
    }
    const res = {
      totalLen: packageSize,
      receivedLen: 0,
      state: this.getStatusCode(type),
    };
    if (type === SPARK_APP_STATUS_PAUSE && downProcess > 0) {
      res.receivedLen = parseInt(downProcess / 100 * packageSize, 10);
      return res;
    }
    res.receivedLen = progress > 0 ? parseInt(progress / 100 * packageSize, 10) : 0;
    return res;
  };
  this.checkDownloadState = (callback) => {
    console.log('--------------checkDownloadState -this.gameInfo=', this.gameInfo);
    this.startDownload(callback, true);
  };
  // 暂停下载
  this.stopDownloadApp = (callback) => {
    console.log('android stopDownloadApp spark ', this.gameInfo);
    const that = this;
    window.SX_WEB?.jsBridge.app.downloadApk({
      actionCode: SPARK_APP_PAUSE_DOWNLOAD_CODE,
      ...this.gameInfo,
      callback: async (res) => {
        console.log('stopDownloadApp spark callback', res);
        if (typeof callback === 'function') {
          const simulateInfo = that.getSimulateInfo(res);
          console.log('getSimulateInfo =', simulateInfo);
          callback(simulateInfo);
        }
      },
    });
  };
  this.isAppInstalled = async () => await window.SX_WEB?.jsBridge.app.isAppInstalled({
    identifier: this.gameInfo.packageName,
  });
  this.installGame = () => {
    console.log('android installGame spark ', this.gameInfo);
    this.startDownload(null, true);//  实现点击触发按钮s
  };
  this.callGame = () => {
    console.log('android callGame spark ', this.gameInfo.packageName);
    window.SX_WEB?.jsBridge.app.launchApp({
      identifier: this.gameInfo.packageName,
    }).then((res) => {
      console.log('launchApp res', res);
    });
  };
  this.beforeDownloadCheck = () => '';
  this.getAppVersion = function () {
    const str = window.navigator.userAgent;
    if (!str) {
      return '';
    }
    if (str.match('com.tencent.gamecommunity') === null) {
      return '';
    }
    let reg = [];
    if (window.SX_WEB.tool.env.ios) {
      reg = new RegExp('com.tencent.gamecommunity/([0-9.]+)');
    } else {
      reg = new RegExp('VERSION_NAME/([0-9.]+)');
    }
    const res = str.match(reg);
    if (!res?.[1]) {
      return '';
    }
    if (!res[1] instanceof Array || res[1].length === 0) {
      return '';
    }
    return res[1];
  };
  this.needReportDownloadPause = true;
  this.needReportDownloadFinish = true;
  this.needReportInstallGame = true;
  this.needReportlaunchGame = true;
  /**
   * 检测当前app是否大于某个版本
   * @param versions  版本参数[6, 2, 0, 1]
   * @returns {boolean}
   */
  this.isAppVersionBiggerThan = (versions) => {
    const currentVersion = this.getAppVersion();
    if  (!currentVersion) {
      return  false;
    }
    const [v1 = 0, v2 = 0, v3 = 0, v4 = 0] = currentVersion.split('.').map(num => parseInt(num, 10));
    console.log('currentVersion spark app v1 v2 v3 v4', v1, v2, v3, v4);
    const [c1 = 0, c2 = 0, c3 = 0, c4 = 0] = versions;
    console.log('passThrough spark app c1 c2 c3 c4', c1, c2, c3, c4);
    if (v1 - c1 < 0) {
      return false;
    }
    if (v1 - c1 > 0) {
      return true;
    }
    if (v2 - c2 < 0) {
      return false;
    }
    if (v2 - c2 > 0) {
      return true;
    }
    if (v3 - c3 < 0) {
      return false;
    }
    if (v3 - c3 > 0) {
      return true;
    }
    if (v4 - c4 < 0) {
      return false;
    }
    if (v4 - c4 > 0) {
      return true;
    }
    if (v1 === c1 && v2 === c2 && v3 === c3 && v4 === c4) {
      return false;
    }
    return false;
  };
  this.startPreDownload = (packageName) => {
    try {
      console.log('access spark app startPreDownload ------packageName = ', packageName);
      const res =  window.SX_WEB?.jsBridge.sxapp.startPreDownload(packageName);
      console.log('access spark app startPreDownload ------packageName  and res  =  ', packageName, res);
    } catch (e) {
      console.error('startPreDownload err msg =  ', e);
    }
  };
  /**
   * @param packageName
   * @returns {Promise<*>}
   * ret;  状态码：0正常，可读取进度;1，未启动，先调用启动下载接口；-1，当前游戏无需预下载
   * receivedLen;    已下载长度，单位是bytes
   * totalLen：总长度
   * path;           文件存储路径
   * totalCount;     预下载资源包总数
   * downLoadCount;  已下载的资源包个数
   */
  this.getPreDownloadProcess = async (packageName) => {
    console.log('access spark app getPreDownloadProcess ------');
    // return { ret: 0, totalCount: 1, downLoadCount: 1, recevivedLen: 30, totalLen: 100 };
    const res = await   window.SX_WEB?.jsBridge.sxapp.getPreDownloadProcess(packageName);
    console.log(' query spark app getPreDownloadProcess  =', res);
    const  { result  = -1, data = {} } = res || {};
    if (result !== 0) {
      // 获取预下载失败
      return { ret: -1, totalCount: 0, downLoadCount: 0, recevivedLen: 0, totalLen: 0 };
    }
    data.recevivedLen = data.receivedLen;
    return data;
  };
  // 闪现预下载前置判断
  this.beforePreDownloadCheck = () => {
    if  (!this.isAppVersionBiggerThan([1, 9, 14, 148])) {
      return  '请更新闪现APP至1.9.14.150版本后进行预下载~';
    }
    return  '';
  };
  console.log('---------------------init done HandleSparkAppClientDownload');
  return this;
}

export default HandleSparkAppClientDownload;
export { HandleSparkAppClientDownload };
